import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  bugReportsListSearch: {
    marginBottom: '4px',
  },
  bugReportsList: {
    '& > div + div': {
      marginTop: theme.spacing(1),
    },
  },
}));
